import { useEffect, useId, useRef, useState } from "react";
import { googleCalendarUrl, icsUrl, outlookCalendarUrl } from "../lib/calendar.js";

/**
 * Kleines Menu, um einen Anlass in den eigenen Kalender zu übernehmen.
 * Google und Outlook öffnen im Browser, die .ics-Datei deckt Outlook auf dem
 * Rechner, Apple Kalender und Thunderbird ab.
 */
export default function AddToCalendar({ ev, align = "left" }) {
  const [open, setOpen] = useState(false);
  const box = useRef(null);
  const menuId = useId();

  useEffect(() => {
    if (!open) return;

    const onPointer = (e) => {
      if (box.current && !box.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === "Escape") {
        setOpen(false);
        box.current?.querySelector("button")?.focus();
      }
    };

    document.addEventListener("mousedown", onPointer);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onPointer);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  const siteUrl = typeof window === "undefined" ? "" : `${window.location.origin}/#anlaesse`;
  const close = () => setOpen(false);

  return (
    <div className="cal" ref={box}>
      <button
        className="cal-trigger"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-haspopup="menu"
        aria-controls={open ? menuId : undefined}
      >
        <svg viewBox="0 0 16 16" aria-hidden="true" className="cal-icon">
          <rect x="1.5" y="3" width="13" height="11.5" rx="2" fill="none" stroke="currentColor" strokeWidth="1.4" />
          <path d="M1.5 6.5h13M5 1.5v3M11 1.5v3" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        </svg>
        Zum Kalender
      </button>

      {open ? (
        <div className="cal-menu" id={menuId} role="menu" data-align={align}>
          <a
            role="menuitem"
            href={googleCalendarUrl(ev, siteUrl)}
            target="_blank"
            rel="noreferrer"
            onClick={close}
          >
            Google Kalender
          </a>
          <a
            role="menuitem"
            href={outlookCalendarUrl(ev, "work", siteUrl)}
            target="_blank"
            rel="noreferrer"
            onClick={close}
          >
            Outlook (Microsoft 365)
          </a>
          <a
            role="menuitem"
            href={outlookCalendarUrl(ev, "personal", siteUrl)}
            target="_blank"
            rel="noreferrer"
            onClick={close}
          >
            Outlook.com
          </a>
          <a role="menuitem" href={icsUrl(ev)} onClick={close}>
            Kalenderdatei (.ics)
            <small>Outlook am Rechner, Apple Kalender</small>
          </a>
        </div>
      ) : null}
    </div>
  );
}
